<template>
  <div style="background:#fef9ef;">
    <v-container>
      <v-app-bar color="#fef9ef" flat>
        <v-app-bar-nav-icon
          class="hidden-md-and-up"
          @click="showMenu = true"
        ></v-app-bar-nav-icon>

        <v-toolbar-title>
          <v-img
            :src="require('../assets/logo.png')"
            contain
            max-width="24vh"
          />
        </v-toolbar-title>
        <v-spacer class="d-none d-md-flex"></v-spacer>
        <v-toolbar-items class="d-none d-md-flex">
          <!-- <router-link to="/home">Home</router-link> -->
          <v-btn color="orange darken-5" to="/home" text small class="mx-2">
            Home
          </v-btn>
          <v-btn color="orange darken-5" to="/tours" text small class="mx-2">
            Tours
          </v-btn>
          <!--           <v-btn color="orange darken-5" to="/docs" text small class="mx-2">
            Documents
          </v-btn> -->
<!--           <v-btn color="orange darken-5" to="/about" text small class="mx-2">
            About us
          </v-btn> -->
          <v-btn color="orange darken-5" to="/contact" text small class="mx-2">
            Contact
          </v-btn>
          <lang-switch> </lang-switch>
        </v-toolbar-items>
      </v-app-bar>
    </v-container>

    <v-main style="background:#fcf9f4;" z-index="20">
      <!--       <v-slide-y-transition> -->
      <router-view></router-view>
      <!--       </v-slide-y-transition> -->
    </v-main>

    <Footer />

    <v-navigation-drawer v-model="showMenu" absolute temporary>
      <v-list nav dense>
        <v-list-item-group
          v-model="group"
          active-class="deep-purple--text text--accent-4"
        >
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Account</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import LangSwitch from "@/components/LangSwitch";
import Footer from "@/components/Footer";
export default {
  data: () => ({
    group: null,
    showMenu: false,
    links: ["Home", "Paket Tour", "About", "Contact"]
  }),
  components: {
    LangSwitch,
    Footer
  }
};
</script>

<style>
.v-btn--active.v-btn--flat.v-btn--router {
}
</style>
